/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import AutomaticallyLimitnumberComponents from 'components/AutomaticallyLimitnumber/automaticallyLimitnumber.components';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const AutomaticallyLimitnumberPage = () => {
   return (
      <Fragment>
         <Helmet>
            <title>เลขอั้นอัตโนมัติ</title>
         </Helmet>
         <HasAccess
            roles={['Owner']}
            permissions={["period-list"]}
            renderAuthFailed={<ErrorPage404/>}
         >
            <AutomaticallyLimitnumberComponents/>
         </HasAccess>
      </Fragment>
   );
};

export default AutomaticallyLimitnumberPage;
